(function () {
  const mainButtons = document.querySelectorAll('.size-guide__button');

  if (mainButtons.length === 0) return;

  document.addEventListener('productoptions.appLoad', (event) => {
    const eventFields = event.detail.fields;
    if (!Array.isArray(eventFields) || eventFields.length === 0) return;
    const firstFieldSet = eventFields[0];
    if (!firstFieldSet) return;

    mainButtons.forEach((mainButton) => {
      if (!mainButton.dataset.keywords) return;

      const keywords = mainButton.dataset.keywords.split(',').map((keyword) => keyword.toLowerCase());
      if (keywords.length === 0) return;

      const selectFields = firstFieldSet.filter(
        (field) =>
          field.type === 'combo_select' ||
          field.type === 'select' ||
          field.type === 'combo_image' ||
          field.type === 'swatch_select_image' ||
          field.type === 'file',
      );
      if (selectFields.length === 0) return;

      const targetField = (mainButton.dataset.targetField || 'first').toLowerCase();

      const matched = selectFields.filter((field) => {
        const labelProduct = field.label_product ? field.label_product.toLowerCase() : '';
        return keywords.some((keyword) => labelProduct.includes(keyword));
      });
      if (matched.length === 0) return;

      (targetField === 'all' ? matched : [matched[0]]).forEach((field, index) => {
        if (!field.key) return;
        const labelTooltip = document.querySelector(`.avp-option[key="${field.key}"] .ap-label-tooltip`);
        if (!labelTooltip) return;

        const btn = index === 0 ? mainButton : mainButton.cloneNode(true);
        if (!labelTooltip.contains(btn)) {
          labelTooltip.appendChild(btn);
        }
        btn.style.display = '';

        // clones need a manual handler since window.load has already fired
        if (index > 0 && !btn._sgClickAttached) {
          btn._sgClickAttached = true;
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const modal = document.querySelector(`product-modal-dialog-by-target[data-target="${btn.getAttribute('href')}"]`);
            if (modal && typeof modal.show === 'function') modal.show(btn);
          });
        }
      });
    });
  });
})();
